import { BUTTERFLY_BUSH, CHART_BACKGROUND_COLOR, HALF_BAKED, MAGIC_MINT } from '../../../utils/colors';
import { STROKE_STYLE } from '../charts.constants';

export const BUBBLE_DEFAULT = {
  legendVisibility: true,
  titlesVisibility: true,
  // DATA
  bubbleValueFormatter: (value) => Math.round(value * 10) / 10,
  // GRID
  gridVisible: true,
  gridBackground: CHART_BACKGROUND_COLOR,
  gridRowLineStyle: STROKE_STYLE,
  gridColumnLineStyle: STROKE_STYLE,
  // x AXIS
  xAxisVisible: true,
  xAxisSpace: 20,
  // x AXIS
  yAxisVisible: true,
  yAxisSpace: 40,
  // BUBBLE MARGINS & PADDINGS
  margin: 0.05,
  // COLORS
  colors: [
    MAGIC_MINT, // WORSE
    HALF_BAKED,
    BUTTERFLY_BUSH, // BETTER
  ],
};
